import { render } from "./TopNavbar.vue?vue&type=template&id=1422efb8"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script